(function() {
  'use strict';
  
  console.log('=== Image Switcher (Alt-Text OR Filename) ===');
  
  let currentColor = null;

  function imageMatchesColor(img, color) {
    if (!img) return false;
    
    // Remove spaces from color for matching
    const colorNoSpaces = color.replace(/\s+/g, '').toLowerCase();
    
    // Check 1: Alt-Text (with and without spaces)
    if (img.alt) {
      const altLower = img.alt.toLowerCase();
      // Check with original color (with spaces)
      if (altLower.indexOf(color.toLowerCase()) !== -1) {
        return true;
      }
      // Check with spaces removed
      const altNoSpaces = img.alt.replace(/\s+/g, '').toLowerCase();
      if (altNoSpaces.indexOf(colorNoSpaces) !== -1) {
        return true;
      }
    }
    
    // Check 2: Filename (from src attribute)
    if (img.src) {
      // Extract filename from URL
      const urlParts = img.src.split('/');
      const filename = urlParts[urlParts.length - 1];
      
      // Remove query parameters (?v=123, &width=800, etc.)
      const filenameClean = filename.split('?')[0].split('&')[0];
      const filenameLower = filenameClean.toLowerCase();
      
      // Check with spaces removed
      const filenameNoSpaces = filenameClean.replace(/\s+/g, '').toLowerCase();
      if (filenameNoSpaces.indexOf(colorNoSpaces) !== -1) {
        return true;
      }
    }
    
    return false;
  }

  // NEU: Prüfe ob ein Element in Produktempfehlungen ist
  function isInRecommendations(element) {
    return element.closest('.product-recommendations, [data-product-recommendations], .related-products, .complementary-products, .recommendations, [data-section-type="related-products"]');
  }

  function forceHideImages() {
    if (!currentColor) return;
    
    // WICHTIG: Nur auf der Produktseite filtern, nicht auf "You may also like"
    if (!document.querySelector('input[type="radio"][name*="Farbe"]')) return;

    // 1. Filter slideshow slides (main image)
    const allSlides = document.querySelectorAll('slideshow-slide');
    allSlides.forEach(function(slide) {
      // NEU: Überspringe Bilder in Empfehlungen
      if (isInRecommendations(slide)) return;
      
      const img = slide.querySelector('img');
      if (!img || !imageMatchesColor(img, currentColor)) {
        slide.style.setProperty('display', 'none', 'important');
      } else {
        slide.style.removeProperty('display');
      }
    });
    
    // 2. Filter thumbnail controls (right side thumbnails)
    const allThumbnails = document.querySelectorAll('slideshow-controls button, [data-thumbnail], .slideshow-control');
    allThumbnails.forEach(function(thumb) {
      // NEU: Überspringe Bilder in Empfehlungen
      if (isInRecommendations(thumb)) return;
      
      const img = thumb.querySelector('img');
      if (!img || !imageMatchesColor(img, currentColor)) {
        thumb.style.setProperty('display', 'none', 'important');
      } else {
        thumb.style.removeProperty('display');
      }
    });
    
    // 3. Filter media list items
    const mediaItems = document.querySelectorAll('.product__media-list li, [data-media-item]');
    mediaItems.forEach(function(item) {
      // NEU: Überspringe Bilder in Empfehlungen
      if (isInRecommendations(item)) return;
      
      const img = item.querySelector('img');
      if (!img || !imageMatchesColor(img, currentColor)) {
        item.style.setProperty('display', 'none', 'important');
      } else {
        item.style.removeProperty('display');
      }
    });
    
    // 4. Filter grid images (for Radiant theme)
    const gridItems = document.querySelectorAll('.media-gallery__grid > li.product-media-container');
    gridItems.forEach(function(item) {
      // NEU: Überspringe Bilder in Empfehlungen
      if (isInRecommendations(item)) return;
      
      const img = item.querySelector('img');
      if (!img || !imageMatchesColor(img, currentColor)) {
        item.style.setProperty('display', 'none', 'important');
      } else {
        item.style.removeProperty('display');
      }
    });
  }

  function updateVisibleImages(color) {
    currentColor = color;
    console.log('>>> Filtering by: "' + color + '"');
    forceHideImages();
  }

  // Apply continuously every 100ms
  setInterval(function() {
    if (currentColor) {
      forceHideImages();
    }
  }, 100);

  // Find color radio buttons
  const colorInputs = document.querySelectorAll('input[type="radio"][name*="Farbe"]');
  console.log('Found ' + colorInputs.length + ' color inputs');
  
  if (colorInputs.length === 0) return;

  // Add event listeners
  colorInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      if (this.checked) {
        console.log('!!! Color changed to: ' + this.value);
        updateVisibleImages(this.value);
      }
    });
  });

  // Apply initial filter
  setTimeout(function() {
    const checked = document.querySelector('input[type="radio"][name*="Farbe"]:checked');
    if (checked) {
      console.log('Initial color: ' + checked.value);
      updateVisibleImages(checked.value);
    }
  }, 100);
})();